// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e3IaE","titleSection":"styles_titleSection__pqemq","title":"styles_title__uS4Ch","subtitle":"styles_subtitle__ZknPs"};